import Users from "../views/Users/Users.jsx";
import Companies from "../views/Companies/Companies.jsx";
import CompanyProfile from "../views/Companies/CompanyProfile.jsx";

var dashRoutes = [
  {
    path: "/companies",
    name: "Empresas",
    icon: "pe-7s-portfolio",
    component: Companies,
  },
  { path: "/users", name: "Usuários", icon: "pe-7s-users", component: Users },
  {
    path: "/company/:companyID",
    name: "Visão geral",
    component: CompanyProfile,
    invisibleInSidebar: true,
  },
];
export default dashRoutes;



// WEBPACK FOOTER //
// ./src/routes/dash.jsx